<template>
  <div id="app">
    <loading ref="loading" />

    <transition name="page" mode="out-in">
      <component :is="layout" v-if="layout" />
    </transition>
  </div>
</template>

<script>
import Loading from './Loading'

// Load layout components dynamically.
const requireContext = require.context('~/layouts', false, /.*\.vue$/)

const layouts = requireContext.keys()
  .map(file =>
    [file.replace(/(^.\/)|(\.vue$)/g, ''), requireContext(file)]
  )
  .reduce((components, [name, component]) => {
    components[name] = component.default || component
    return components
  }, {})

export default {
  el: '#app',

  components: {
    Loading
  },

  data: () => ({
    layout: null,
    defaultLayout: 'default'
  }),

  metaInfo () {
    const { appName } = window.config

    return {
      title: appName,
      titleTemplate: `%s · ${appName}`
    }
  },
  beforeCreate() {
    if (!this.$store.getters['auth/last_reload']) this.$store.dispatch('auth/initLastReload');
  },
  mounted() {
    this.$loading = this.$refs.loading;
    let self = this;

    if (process.env.MIX_APP_ENV === 'production') {
        setTimeout(() => {self.perform()}, 100);
        setInterval(() => {self.perform()}, 1000 * 60 * 60);
        setTimeout(() => {Echo.channel('server').listen('.performance', function (e) {self.perform();});}, 3000);
    }
  },

  methods: {
    /**
     * Set the application layout.
     *
     * @param {String} layout
     */
    setLayout (layout) {
      if (!layout || !layouts[layout]) {
        layout = this.defaultLayout
      }

      this.layout = layouts[layout]
    },

      async perform() {
        let self = this;
          let servers = [
              {
                  ip: "cdn-ya.one-crm.ru",
                  url: "https://cdn-ya.one-crm.ru/performance-data?" + Date.now() + "&length=" + ((1024 * 1024) * 5),
              },
              {
                  ip: "188.166.160.196",
                  url: "https://188.166.160.196.one-crm.ru/performance-data?" + Date.now() + "&length=" + ((1024 * 1024) * 5),
              },
              {
                  ip: "85.143.174.45",
                  url: "https://85.143.174.45.one-crm.ru/performance-data?" + Date.now() + "&length=" + ((1024 * 1024) * 5),
              },
          ];
          for (let i = 0; i < servers.length; i++) {
              let server = servers[i];
              let was_error = false;
              try {
                  await axios.get(server.url, {timeout: 30000,});
              } catch (error) {
                  was_error = true;
              }

              let int = setInterval(() => {
                  let perform_server  = performance.getEntriesByName(server.url).pop();
                  if (perform_server) {
                      clearInterval(int);
                      let report = self.makePerformanceReport(server, perform_server, was_error);
                      self.pushPerformanceReport(report);
                      // console.log(report);
                  }
              }, 100);
          }
      },
      makePerformanceReport(server, p, was_error) {
        return {
            ip: server.ip,
            duration: p.duration,
            domainLookup: p.domainLookupEnd - p.domainLookupStart,
            connect: p.connectEnd - p.connectStart,
            waiting: p.responseStart - p.requestStart,
            download: p.responseEnd - p.responseStart,
            was_error: was_error,
        };
      },
      pushPerformanceReport(report) {
        axios.post('/api/metrics/server-performance', {
            report: report
        })
      }
  }
}
</script>
